document.body.addEventListener('click', function (evt) {
	if (!evt.target.closest('.dropdown')) return;
	evt.target.closest('.dropdown').classList.toggle('--open');
});

document.querySelectorAll('.dropdown').forEach((elem, idx) => {
	elem.addEventListener('mouseleave', function (evt) {
		evt.target.closest('.dropdown').classList.remove('--open');
	});
});

document.querySelectorAll('.dropdown__options ul li a').forEach((elem, idx) => {
	elem.addEventListener('click', function (evt) {
		evt.target.closest('li').classList.add('--selected');
	});
});
